export class InspectionUploadArgs {
    PolicyId: string;
    FileName: string;
    Attachment: string;
    TenantId: string = "5EA8C224-B3FF-4F11-B09F-5EC0C65266EC";
}
